function TdEditPassword(props) {

  // Define variables
  const editPasswordFunction = props.editPasswordFunction;
  const object = props.object;
  const role = object.role;


  // Screen components
  let bodyElement;
  if( role != 'Admin') {
    bodyElement = (
      <button
        onClick={() => editPasswordFunction(object)}
        class='icon icon-key'
        title='Edit password'
      />
    );
  }


  return(
    <td class='td-icon'>
      <>{bodyElement}</>
    </td>
  );
}

export default TdEditPassword;